import React from 'react';

import { SVGComponentProps } from './svg.types';

const TaskHistoryDateSVG = ({
  fill = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="16" cy="16" r="16" fill="#EEF1FC" />
        <path
          d="M20.9 11.1H20.2V9.7C20.2 9.51435 20.1263 9.3363 19.995 9.20503C19.8637 9.07375 19.6857 9 19.5 9C19.3143 9 19.1363 9.07375 19.005 9.20503C18.8737 9.3363 18.8 9.51435 18.8 9.7V11.1H13.2V9.7C13.2 9.51435 13.1262 9.3363 12.995 9.20503C12.8637 9.07375 12.6857 9 12.5 9C12.3143 9 12.1363 9.07375 12.005 9.20503C11.8737 9.3363 11.8 9.51435 11.8 9.7V11.1H11.1C10.543 11.1 10.0089 11.3212 9.61508 11.7151C9.22125 12.1089 9 12.643 9 13.2V13.9H23V13.2C23 12.643 22.7788 12.1089 22.3849 11.7151C21.9911 11.3212 21.457 11.1 20.9 11.1Z"
          fill={fill}
        />
        <path
          d="M9 20.9008C9 21.4577 9.22125 21.9919 9.61508 22.3857C10.0089 22.7795 10.543 23.0008 11.1 23.0008H20.9C21.457 23.0008 21.9911 22.7795 22.3849 22.3857C22.7788 21.9919 23 21.4577 23 20.9008V15.3008H16H9V20.9008Z"
          fill={fill}
        />
      </svg>
    </span>
  );
};

export default TaskHistoryDateSVG;
